/**
 * Component for rendering a card
 */

import { Component, Input, HostBinding } from '@angular/core';
import { Sizes } from '../va-cards.interface';

@Component({
  selector: 'va-card',
  templateUrl: './va-card.component.html',
  styleUrls: ['./va-card.component.scss'],
})
export class VaCardComponent {
  @Input() size?: Sizes = Sizes.OneThird;
  @HostBinding('class.size-one-third') @Input() get isOneThird(): boolean {
    return this.size === Sizes.OneThird;
  }
  @HostBinding('class.size-half') @Input() get isHalf(): boolean {
    return this.size === Sizes.Half;
  }
  @HostBinding('class.size-two-thirds') @Input() get isTwoThird(): boolean {
    return this.size === Sizes.TwoThirds;
  }
  @HostBinding('class.size-full') @Input() get isFull(): boolean {
    return this.size === Sizes.Full;
  }
}
